import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { useQueryClient } from 'react-query';
import CollectionKeys from '../../../hooks/molecules/collection-keys';
import { useItems } from '../../../hooks/atoms/items-hook';
import AppLoader from '../../basic/AppLoader';
import AppTable from '../../basic/AppTable';
import SimulationGroup from './simulation-groups/SimulationGroup';
import AppButtonMain from '../../basic/AppButtonMain';
import { getTheme } from '../../../theme';
import { useDialog } from '../../../dialog-provider-hooks';
import axiosClient from '../../../http/axios-client';
import { useAlerts } from '../../../hooks/alerts-hooks';

const tableColumns = [
  { id: 1, label: 'ID', field: 'id' },
  { id: 2, label: 'Simulation ID', field: 'simulation_id' },
  { id: 3, label: 'Status', field: 'status' },
  { id: 4, label: 'Version ID', field: 'version.id' },
  { id: 5,
    label: 'Groups',
    field: 'groups',
    customRenderer({ value: groups }) {
      if (null === groups || !Array.isArray(groups) || 0 === groups.length) {
        return <p>No groups</p>;
      }
      return <p>{`${ groups.length } group(s)`}</p>;
    } },
  { id: 6,
    label: '',
    customRenderer({ row: simulation }) {
      const { openDialog } = useDialog();

      const queryClient = useQueryClient();
      const { alertError } = useAlerts();

      const openApproveSimulationDialog = () => {
        openDialog({
          title: 'Approve simulation ?',
          body() {
            return (
              <>
                <p style={ { maxWidth: '400px' } }>
                  Are you sure you want to approve the simulation
                  {' '}
                  <strong>{simulation.simulation_id}</strong>
                  {' '}
                  ?
                </p>
              </>
            );
          },
          onSubmit() {
            return queryClient.executeMutation(
              {
                mutationKey: [ CollectionKeys.SIMULATIONS, 'APPROVE', simulation.id ],
                mutationFn: () => {
                  return axiosClient.post('edag/prescoring/approve', {
                    simulation: simulation.simulation_id,
                    scoring_method: 'non-parametric',
                    status: 'approved',
                  }).catch((err) => {
                    throw err;
                  });
                },
                onError() {
                  return alertError('Something went wrong');
                },
                onSettled() {
                  return queryClient.invalidateQueries([ CollectionKeys.VERSIONS ]);
                },
              },
            );
          },
        });
      };
      if ('success' !== simulation.status) {
        return null;
      }
      return (
        <AppButtonMain
          color={ getTheme().palette.info.main }
          text='Approve'
          onClick={ () => { return openApproveSimulationDialog(); } }
        />
      );
    } },
];

const VersionSimulations = (
  {
    version,
  },
) => {
  const [ activeSimulation, setActiveSimulation ] = useState(null);

  const {
    items: simulations,
    itemsLoading: simulationsLoading,
    pagination,
  } = useItems(CollectionKeys.SIMULATIONS, {
    filterQuery: {
      'version.id_eq': version?.id,
    },
    queryOptions: {
      enabled: !!version,
    },
  });

  if (simulationsLoading) {
    return <AppLoader />;
  }

  return (
    <Grid container item xs={ 12 }>
      <Grid item xs={ 12 }>
        <AppTable
          columns={ tableColumns }
          paginationProps={ pagination }
          loading={ simulationsLoading }
          data={ simulations }
          ViewProp={ {
            handleView: (e, simulationId) => {
              setActiveSimulation(simulations.find((s) => { return s.id === simulationId; }));
            },
          } }
          activeProps={ { active: null === activeSimulation ? [] : [ activeSimulation.id ] } }
        />
      </Grid>
      <Grid container item xs={ 12 }>
        {
          activeSimulation && activeSimulation.groups?.map((g) => {
            return (
              <Grid key={ g.name } item xs={ 12 }>
                <SimulationGroup group={ g } />
              </Grid>
            );
          })
        }
      </Grid>
    </Grid>
  );
};

export default VersionSimulations;
